/**
 * Word-by-word Karaoke Subtitle and Caption Renderer.
 */
import { SVGObject, SVGObjectConfig } from '../objects/SVGObject';
import { Renderer } from '../core/Renderer';

export class SubtitleOverlay extends SVGObject {
  private fullText: string = '';
  private activeWordIndex: number = -1;
  private bgRect: SVGRectElement;
  private textEl: SVGTextElement;

  constructor(config: SVGObjectConfig) {
    super({ ...config, type: 'subtitle', layer: 'ui' });
    this.bgRect = Renderer.createElement('rect');
    this.textEl = Renderer.createElement('text');
    if ((config as any).props?.text) {
      this.fullText = (config as any).props.text;
    }
  }

  public override setSelected(selected: boolean): void {
    super.setSelected(selected);
    if (selected && !this.fullText) {
      this.render();
    }
  }

  public render(): void {
    this.container.innerHTML = '';
    const displayText = this.fullText || (this.isSelected ? '[Voiceover Subtitles Preview]' : '');
    if (!displayText) return;

    // Background glass pill
    Renderer.setAttributes(this.bgRect, {
      x: -350,
      y: 460,
      width: 700,
      height: 48,
      rx: 24,
      ry: 24,
      fill: 'rgba(15, 23, 42, 0.88)',
      stroke: 'rgba(56, 189, 248, 0.3)',
      'stroke-width': 1.5,
      filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.5))'
    });
    this.container.appendChild(this.bgRect);

    // Text tspans
    Renderer.setAttributes(this.textEl, {
      x: 0,
      y: 484,
      'font-size': 18,
      'font-family': 'Inter, sans-serif',
      'font-weight': '600',
      'text-anchor': 'middle',
      'dominant-baseline': 'central'
    });

    const words = displayText.split(' ');
    this.textEl.innerHTML = '';

    words.forEach((w, idx) => {
      const span = Renderer.createElement('tspan');
      span.textContent = w + ' ';
      span.setAttribute('fill', idx === this.activeWordIndex ? '#38bdf8' : '#e2e8f0');
      span.setAttribute('font-weight', idx === this.activeWordIndex ? '800' : '500');
      this.textEl.appendChild(span);
    });

    this.container.appendChild(this.textEl);
  }

  public setCaption(text: string): void {
    this.fullText = text;
    this.activeWordIndex = -1;
    this.visible = !!text;
    this.render();
  }

  public highlightWord(wordIndex: number): void {
    this.activeWordIndex = wordIndex;
    this.render();
  }
}
